export const FIND_STATEMENT_TEMPLATE_PLACEHOLDERS_REQUEST = 'FIND_STATEMENT_TEMPLATE_PLACEHOLDERS_REQUEST';

export const findStatementTemplatePlaceholdersRequest = () => ({
    type: FIND_STATEMENT_TEMPLATE_PLACEHOLDERS_REQUEST,
});
